module.exports = __webpack_public_path__ + "img/icon-pay-off-in-n.2b08dbb9.svg";